import { globalToastService } from '@repo/atomic-components';

export const UNVIEWABLE_CHAT_DOCUMENT_TOOLTIP = 'This file cannot be viewed.';

function getDocumentFormat(documentName?: string | null): string | null {
  const name = documentName?.trim();
  if (!name) return null;
  const dot = name.lastIndexOf('.');
  if (dot <= 0) return null;
  const ext = name
    .slice(dot + 1)
    .trim()
    .toLowerCase();
  return ext || null;
}

export function showDocumentPreviewUnsupportedToast(documentName?: string | null): void {
  const format = getDocumentFormat(documentName);
  globalToastService.show({
    closable: true,
    severity: 'error',
    summary: format
      ? `Error: Document format ${format} is not supported for preview`
      : 'Error: This document format is not supported for preview',
    life: 6000,
  });
}
